import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { computed, ref } from "vue";
import { useStore } from "vuex";
import { userProfilesApi } from "@/di/api";
import { useRouter } from "vue-router";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveAccountForm',
  setup(__props) {

const store = useStore()
const router = useRouter()

const isFormSown = ref<boolean>(false)
const model = ref({})
const lock = ref<{ formSubmitting: boolean }>({ formSubmitting: false })

const userProfile = computed(() => store.getters["auth/userProfile"])

async function submitForm (): Promise<void> {
  lock.value.formSubmitting = true

  try {
    await userProfilesApi.removeAccount(userProfile.value.id)

    await store.dispatch('auth/logout')
    await router.push({ name: 'auth' })
  } finally {
    lock.value.formSubmitting = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Remove account")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (!isFormSown.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isFormSown.value = true))
          }, " Remove account "))
        : _createCommentVNode("", true)
    ]),
    (isFormSown.value)
      ? (_openBlock(), _createBlock(_component_FormKit, {
          key: 0,
          modelValue: model.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event)),
          type: "form",
          actions: false,
          onSubmit: submitForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              type: "text",
              name: "confirmation",
              label: "Input your name as confirmation",
              validation: [ ['bail'], ['required'], ['matches', _unref(userProfile).name] ],
              "outer-class": "mb-3"
            }, null, 8, ["validation"]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-danger btn-sm",
              "data-type": "submit",
              disabled: lock.value.formSubmitting
            }, [
              _createVNode(FormKitSubmitButtonContent, null, {
                default: _withCtx(() => [
                  _createTextVNode("Remove")
                ]),
                _: 1
              })
            ], 8, _hoisted_2),
            (isFormSown.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-warning btn-sm",
                  style: {"margin-left":"8px"},
                  disabled: lock.value.formSubmitting,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isFormSown.value = false))
                }, " Cancel ", 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})